module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-800-vietnamese16.0925fd7.woff2";